const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/item-types/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import { itemTypeLevelsQueryOptions } from '@/lib/queries/common/useItemTypeLevelsQuery';
import { itemTypesQueryOptions } from '@/lib/queries/common/useItemTypesQuery';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
export const Route = createFileRoute('/(app)/org/$org/settings/item-types/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await Promise.all([queryClient.ensureQueryData(itemTypesQueryOptions()), queryClient.ensureQueryData(itemTypeLevelsQueryOptions())]);
    return {
      crumb: i18n.t('common.settings.itemTypes.itemTypes')
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t('common.settings.itemTypes.itemTypes')
    }
  }
});